/*
* @描述: 订单详情页
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-08 09:41:04
*/
<template>
    <div v-loading="loading" class="page_container">
        <div class="detail_outer_wrap">
            <div class="detail_top_wrap">
                <div class="flex_js_wrap">
                    <div class="flex_wrap">
                        <i class="iconfont icon-a-dingdan1"></i>
                        <h2 v-text="orderDetailsData.order_num"></h2>
                        <el-tooltip content="复制"
                                    effect="dark"
                                    placement="top">
                                               <span class="handle_icon_wrap" @click="handleClickCopyOrderNum">
                                                   <i class="iconfont icon-fuzhi"></i>
                                               </span>
                        </el-tooltip>
                        <el-tag v-if="orderDetailsData.is_bad_debt===1" size="mini" type="danger">坏账</el-tag>
                    </div>
                    <div class="flex_wrap">
                        <div v-if="orderDetailsData.order_status===0&&order_edit_auth"
                             class="detail_handle_icon_wrap"
                             @click="handleClickRevokeOrder">
                            <i class="iconfont icon-chexiao"></i>
                            <span>撤销</span>
                        </div>
                        <div v-else-if="orderDetailsData.order_status===1&&order_edit_auth"
                             class="detail_handle_icon_wrap"
                             @click="handleClickAfterSales">
                            <i class="iconfont icon-huanhuo1"></i>
                            <span>售后</span>
                        </div>
                        <div v-else-if="orderDetailsData.order_status===4&&order_edit_auth"
                             class="detail_handle_icon_wrap"
                             @click="handleClickEditOrder">
                            <i class="iconfont icon-bianji"></i>
                            <span>编辑</span>
                        </div>
                        <div v-else-if="orderDetailsData.order_status===2||orderDetailsData.order_status===3||orderDetailsData.order_status===5&&order_edit_auth"
                             class="detail_handle_icon_wrap"
                             @click="handleClickSubmitAgain">
                            <i class="iconfont icon-refresh"></i>
                            <span>重新发起</span>
                        </div>
                        <el-dropdown v-if="order_list_auth" placement="bottom-end" trigger="click">
                            <div class="detail_handle_icon_wrap">
                                <i class="iconfont icon-gengduo"></i>
                                <span>更多</span>
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                        v-if="orderDetailsData.order_status===2||orderDetailsData.order_status===3||orderDetailsData.order_status===4||orderDetailsData.order_status===5"
                                        @click.native="handleClickDelOrder">删除
                                </el-dropdown-item>
                                <el-dropdown-item
                                        v-if="orderDetailsData.order_status===0||orderDetailsData.order_status===1"
                                        @click.native="handleClickCopyOrder">复制订单
                                </el-dropdown-item>
                                <el-dropdown-item v-if="order_purchase_add_auth" @click.native="handleClickAddPurchase">
                                    新增代采
                                </el-dropdown-item>
                                <el-dropdown-item v-if="orderDetailsData.order_status===1"
                                                  @click.native="handleClickPrintTheOrder">
                                    打印订单
                                </el-dropdown-item>
                                <el-dropdown-item v-if="orderDetailsData.order_status===1"
                                                  @click.native="handleClickAddMember">
                                    添加成员
                                </el-dropdown-item>
                                <el-dropdown-item
                                        v-if="orderDetailsData.order_status===1&&hasClosePermission"
                                        @click.native="handleClickCloseOrder">
                                    关闭订单
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="flex_wrap">
                    <div class="custom_contact_field_wrap">
                        <PersonnelCard v-if="orderDetailsData.salesperson"
                                       :userId="orderDetailsData.salesperson.value[0]">
                            <template slot="container">
                                <img :src="orderDetailsData.salesperson.text[0].avatar || defaultImg" alt=""
                                     class="avatar">
                                <span class="name" v-text="orderDetailsData.salesperson.text[0].name"></span>
                            </template>
                        </PersonnelCard>
                    </div>
                    <span class="line"></span>
                    <i class="iconfont icon-bumenfuzeren"></i>
                    <span v-if="orderDetailsData.customer_id"
                          class="company_name"
                          v-text="orderDetailsData.customer_id.text"></span>
                    <span class="line"></span>
                    <span class="create_date" v-text="orderDetailsData.created_at"></span>
                </div>
            </div>
            <div class="detail_bottom_wrap">
                <div :class="{'is_collapse':isCollapse}" class="bottom_left_wrap">
                    <div class="collapse_button" @click="handleClickCollapse">
                        <i :class="isCollapse?'el-icon-arrow-left':'el-icon-arrow-right'"></i>
                    </div>
                    <el-tabs v-model="tabActiveName" class="list_page_tabs" @tab-click="handleClickTab">
                        <el-tab-pane label="订单详情" name="detail">
                            <div class="el_tab_pane_wrap order_detail_wrap">
                                <CustomFormDetailPc v-if="dataLoaded"
                                                    :field_form="'orders'"
                                                    :field_list="formInfoList"
                                                    :form_detail="orderDetailsData"
                                                    :is_edit_mode="false"
                                                    :pk_id="orderDetailsData.order_id"
                                                    :goods_price_permission="permission"
                                                    @show-purchase-detail="handleClickShowPurchaseDetail"/>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane v-if="order_list_auth" label="款项记录" name="payment">
                            <div v-loading="listLoading" class="el_tab_pane_wrap">
                                <div v-if="orderDetailsData.order_status === 1&&order_edit_auth"
                                     class="ta_r mb_16">
                                    <el-button size="small" type="primary" @click="handleClickAddRepayment">新建回款
                                    </el-button>
                                </div>
                                <div class="invoice_table_wrap">
                                    <vxe-table :data="paymentRecordList" border>
                                        <vxe-column title="编号" width="160">
                                            <template #default="{ row }">
                                            <span :class="{'link-label':row.type==='repayment'}"
                                                  @click="handleClickRepaymentDetail(row)"
                                                  v-text="row.type==='repayment'?row.receivable_no:row.payable_no"></span>
                                            </template>
                                        </vxe-column>
                                        <vxe-column field="payment_company_name" title="回款客户">
                                            <template #default="{ row }">
                                                <span v-text="row.type==='repayment'?row.payment_company_name:'--'"></span>
                                            </template>
                                        </vxe-column>
                                        <vxe-column title="申请人">
                                            <template #default="{ row }">
                                                <div class="custom_contact_field_wrap">
                                                    <PersonnelCard v-if="row.uid_info"
                                                                   :userId="row.uid_info.id">
                                                        <template slot="container">
                                                            <img :src="row.uid_info.avatar || defaultImg" alt=""
                                                                 class="avatar">
                                                            <span class="name" v-text="row.uid_info.name"></span>
                                                        </template>
                                                    </PersonnelCard>
                                                </div>
                                            </template>
                                        </vxe-column>
                                        <vxe-column field="payment_date" title="回款/退款日期" width="160">
                                            <template #default="{ row }">
                                                <span v-text="row.type==='repayment'?row.payment_date:row.refund_date"></span>
                                            </template>
                                        </vxe-column>
                                        <vxe-column field="return_type_name" title="回款/退款类型">
                                            <template #default="{ row }">
                                                <span v-text="row.type==='repayment'?row.payment_method_name:row.return_type_name"></span>
                                            </template>
                                        </vxe-column>
                                        <vxe-column align="right" title="回款/退款金额">
                                            <template #default="{ row }">
                                            <span :class="{'refund_amount':row.type==='refund'}"
                                                  v-text="'¥'+row.payment_amount"></span>
                                            </template>
                                        </vxe-column>
                                        <vxe-column title="状态">
                                            <template #default="{ row }">
                                            <span :class="row.type==='refund'?'payment_status_name_'+row.payment_status:'payment_status_name_'+row.status"
                                                  class="status_name"
                                                  v-text="row.type==='refund'?row.payment_status_name:row.status_name"></span>
                                                <el-tooltip v-if="row.status===3" :content="row.reject_reason"
                                                            effect="dark"
                                                            placement="top">
                                                 <span class="handle_icon_wrap">
                                                    <i class="iconfont icon-jinggao"></i>
                                                </span>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="row.status===5" :content="row.invalid_reason"
                                                            effect="dark"
                                                            placement="top">
                                                 <span class="handle_icon_wrap">
                                                    <i class="iconfont icon-jinggao"></i>
                                                </span>
                                                </el-tooltip>
                                            </template>
                                        </vxe-column>
                                        <vxe-column fixed="right" title="操作" width="80">
                                            <template #default="{ row }">
                                                <span v-if="row.type==='refund'">--</span>
                                                <div v-else>
                                                    <el-link v-if="row.status===1&&row.uid==userInfo.user.id"
                                                             :underline="false"
                                                             type="danger"
                                                             @click="handleClickPaymentRevoke(row)">撤销
                                                    </el-link>
                                                    <el-link v-else-if="row.status===3||row.status===4||row.status===5"
                                                             :underline="false"
                                                             type="primary"
                                                             @click="handleClickPaymentAgain(row)">重新发起
                                                    </el-link>
                                                </div>
                                            </template>
                                        </vxe-column>
                                    </vxe-table>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane v-if="order_list_auth" label="开票记录" name="invoice">
                            <div v-loading="listLoading" class="el_tab_pane_wrap">
                                <div v-if="orderDetailsData.order_status === 1&&order_edit_auth"
                                     class="ta_r mb_16">
                                    <el-button size="small" type="primary" @click="handleClickAddInvoice">新建开票
                                    </el-button>
                                </div>
                                <div class="invoice_table_wrap">
                                    <vxe-table :data="invoiceSummaryList" border>
                                        <vxe-column title="开票编号" width="160">
                                            <template #default="{ row }">
                                            <span class="link-label" @click="handleClickInvoiceDetail(row)"
                                                  v-text="row.invoice_no"></span>
                                            </template>
                                        </vxe-column>
                                        <vxe-column field="invoice_company_name" title="开票公司"></vxe-column>
                                        <vxe-column title="申请人">
                                            <template #default="{ row }">
                                                <div class="custom_contact_field_wrap">
                                                    <PersonnelCard v-if="row.apply_user_info"
                                                                   :userId="row.apply_user_info.id">
                                                        <template slot="container">
                                                            <img :src="row.apply_user_info.avatar || defaultImg" alt=""
                                                                 class="avatar">
                                                            <span class="name" v-text="row.apply_user_info.name"></span>
                                                        </template>
                                                    </PersonnelCard>
                                                </div>
                                            </template>
                                        </vxe-column>
                                        <vxe-column field="invoice_type_name" title="发票类型"></vxe-column>
                                        <vxe-column align="right" title="本次开票金额">
                                            <template #default="{ row }">
                                                <span v-text="'¥'+row.invoice_amount"></span>
                                            </template>
                                        </vxe-column>
                                        <vxe-column field="apply_time" title="开票申请时间" width="160"></vxe-column>
                                        <vxe-column field="invoice_number" title="发票号码"></vxe-column>
                                        <vxe-column title="状态">
                                            <template #default="{ row }">
                                            <span :class="'invoice_status_name_'+row.status"
                                                  class="status_name"
                                                  v-text="row.status_name"></span>
                                                <el-tooltip v-if="row.status===3" :content="row.reject_reason"
                                                            effect="dark"
                                                            placement="top">
                                                 <span class="handle_icon_wrap">
                                                    <i class="iconfont icon-jinggao"></i>
                                                </span>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="row.status===4" :content="row.invalid_reason"
                                                            effect="dark"
                                                            placement="top">
                                                 <span class="handle_icon_wrap">
                                                    <i class="iconfont icon-jinggao"></i>
                                                </span>
                                                </el-tooltip>
                                            </template>
                                        </vxe-column>
                                        <vxe-column fixed="right" title="操作" width="80">
                                            <template #default="{ row }">
                                                <el-link v-if="row.status===1"
                                                         :underline="false"
                                                         type="danger"
                                                         @click="handleClickInvoiceRevoke(row)">撤销
                                                </el-link>
                                                <el-link v-else-if="row.status===3||row.status===4||row.status===5"
                                                         :underline="false"
                                                         type="primary"
                                                         @click="handleClickInvoiceAgain(row)">重新发起
                                                </el-link>
                                            </template>
                                        </vxe-column>
                                    </vxe-table>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane v-if="order_list_auth" label="出库记录" name="outStock">
                            <div v-loading="listLoading" class="el_tab_pane_wrap order_detail_wrap">
                                <vxe-table :data="stockOutList" border>
                                    <vxe-column field="" title="出库单编号">
                                        <template #default="{ row }">
                                            <span class="link-label" @click="handleClickOutStockDetail(row)"
                                                  v-text="row.log_num"></span>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="" title="操作人">
                                        <template #default="{ row }">
                                            <div class="custom_contact_field_wrap">
                                                <PersonnelCard :userId="row.approval_user.id">
                                                    <template slot="container">
                                                        <img :src="row.approval_user.avatar || defaultImg" alt=""
                                                             class="avatar">
                                                        <span class="name" v-text="row.approval_user.name"></span>
                                                    </template>
                                                </PersonnelCard>
                                            </div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="created_at" title="操作时间"></vxe-column>
                                    <vxe-column field="note" title="备注"></vxe-column>
                                </vxe-table>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane v-if="order_list_auth" label="关联工单" name="workOrder">
                            <div v-loading="listLoading" class="el_tab_pane_wrap order_detail_wrap">
                                <vxe-table :data="workOrderList" border>
                                    <vxe-column field="" title="工单编号">
                                        <template #default="{ row }">
                                            <span class="link-label" @click="handleClickWorkOrderDetail(row)"
                                                  v-text="row.workorder_num"></span>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="" title="发布人">
                                        <template #default="{ row }">
                                            <div v-if="row.user" class="custom_contact_field_wrap">
                                                <PersonnelCard :userId="row.user.id">
                                                    <template slot="container">
                                                        <img :src="row.user.avatar || defaultImg" alt=""
                                                             class="avatar">
                                                        <span class="name" v-text="row.user.name"></span>
                                                    </template>
                                                </PersonnelCard>
                                            </div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="created_at" title="发布时间"></vxe-column>
                                    <vxe-column field="" title="工单实施人">
                                        <template #default="{ row }">
                                            <div v-if="row.processing_users.length" class="flex_wrap_wrap">
                                                <div v-for="(item, index) in row.processing_users"
                                                     :key="index"
                                                     class="custom_contact_field_wrap">
                                                    <PersonnelCard
                                                            v-if="item.processing_user && item.processing_user.id"
                                                            :userId="item.processing_user.id">
                                                        <template slot="container">
                                                            <img
                                                                    :src="item.processing_user.avatar ? item.processing_user.avatar : defaultImg"
                                                                    alt=""
                                                                    class="avatar"
                                                            />
                                                            <span class="name"
                                                                  v-text="item.processing_user.name"></span>
                                                        </template>
                                                    </PersonnelCard>
                                                </div>
                                            </div>
                                            <span v-else>--</span>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="" title="工单状态">
                                        <template #default="{ row }">
                                            <span v-text="row.status_text"></span>
                                        </template>
                                    </vxe-column>
                                </vxe-table>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane v-if="order_list_auth" label="售后记录" name="afterSales">
                            <div v-loading="listLoading" class="el_tab_pane_wrap order_detail_wrap">
                                <vxe-table :data="afterSaleList" border>
                                    <vxe-column field="type_name" title="售后类型"></vxe-column>
                                    <vxe-column title="发布人">
                                        <template #default="{ row }">
                                            <div class="custom_contact_field_wrap">
                                                <PersonnelCard :userId="row.uid">
                                                    <template slot="container">
                                                        <img :src="row.user_avatar || defaultImg" alt=""
                                                             class="avatar">
                                                        <span class="name" v-text="row.user_name"></span>
                                                    </template>
                                                </PersonnelCard>
                                            </div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="created_at" title="售后时间" width="160"></vxe-column>
                                    <vxe-column title="售后状态">
                                        <template #default="{ row }">
                                            <span :class="'approval_status_'+row.approval_status"
                                                  class="status_name"
                                                  v-text="row.approval_status_name"></span>
                                        </template>
                                    </vxe-column>
                                    <vxe-column fixed="right" title="操作" width="100">
                                        <template #default="{ row }">
                                            <el-link v-if="row.approval_status===0"
                                                     :underline="false"
                                                     type="danger"
                                                     @click="handleClickAfterSaleRevoke(row)">撤销
                                            </el-link>
                                            <span v-if="row.approval_status===0" class="line"></span>
                                            <el-link :underline="false"
                                                     type="primary"
                                                     @click="handleClickAfterSaleDetail(row)">详情
                                            </el-link>
                                        </template>
                                    </vxe-column>
                                </vxe-table>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane v-if="order_list_auth" label="团队成员" name="member">
                            <div v-loading="listLoading" class="el_tab_pane_wrap order_detail_wrap">
                                <div v-if="orderDetailsData.order_status === 1&&order_edit_auth"
                                     class="ta_r mb_16">
                                    <el-button size="small" type="primary" @click="handleClickAddMember">添加成员
                                    </el-button>
                                </div>
                                <div class="invoice_table_wrap">
                                    <vxe-table :data="teamMemberList" border>
                                        <vxe-column field="" title="成员姓名" width="220">
                                            <template #default="{ row }">
                                                <div class="custom_contact_field_wrap">
                                                    <PersonnelCard :userId="row.member_uid">
                                                        <template slot="container">
                                                            <img :src="row.user_avatar || defaultImg" alt=""
                                                                 class="avatar">
                                                            <span class="name" v-text="row.user_name"></span>
                                                        </template>
                                                    </PersonnelCard>
                                                </div>
                                            </template>
                                        </vxe-column>
                                        <vxe-column field="" title="权限">
                                            <template #default="{ row }">
                                                <el-radio-group v-model="row.auth"
                                                                @change="handleOrderMemberAuthChange(row)">
                                                    <el-radio :label="1">只读</el-radio>
                                                    <el-radio :label="2">读写</el-radio>
                                                </el-radio-group>
                                            </template>
                                        </vxe-column>
                                        <vxe-column fixed="right" title="操作" width="60">
                                            <template #default="{ row }">
                                                <el-link :underline="false"
                                                         type="danger"
                                                         @click="handleClickRemoveMember(row)">移除
                                                </el-link>
                                            </template>
                                        </vxe-column>
                                    </vxe-table>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane v-if="order_list_auth" label="日志" name="log">
                            <div v-loading="listLoading" class="el_tab_pane_wrap order_detail_wrap">
                                <ul class="order_log_list">
                                    <li v-for="item in orderLogList" :key="item.order_log_id" class="order_log_item">
                                        <div class="flex_wrap">
                                            <div class="custom_contact_field_wrap">
                                                <PersonnelCard :userId="item.uid">
                                                    <template slot="container">
                                                        <img :src="item.user_avatar || defaultImg" alt=""
                                                             class="avatar">
                                                        <span class="name" v-text="item.user_name"></span>
                                                    </template>
                                                </PersonnelCard>
                                            </div>
                                            <div class="created_at" v-text="item.created_at"></div>
                                        </div>
                                        <div v-if="item.content" class="log_content_wrap">
                                            <div v-if="item.type ==='order_edit'">
                                                <h4>售后-订单编辑</h4>
                                                <div class="order_edit_content">
                                                    <afterSaleApproveDetail :after_sales_type="item.type"
                                                                            :form_detail="item.content.details"
                                                                            :label_position="'left'"/>
                                                </div>
                                            </div>
                                            <div v-else
                                                 class="log_content"
                                                 v-html="item.content.details"></div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div :class="{'is_collapse':isCollapse}" class="bottom_right_wrap">
                    <div class="payments_overview_wrap">
                        <div class="flex_js_wrap">
                            <div class="page_little_title">
                                <span class="title">款项概况</span>
                            </div>
                            <el-link :underline="false"
                                     icon="el-icon-plus"
                                     type="primary"
                                     v-if="orderDetailsData.order_status === 1&&order_edit_auth"
                                     @click="handleClickAddRepayment">新建回款
                            </el-link>
                        </div>
                        <div v-if="order_list_auth" class="payments_chart_wrap flex_js_wrap">
                            <div class="left_progress_wrap">
                                <!--总回款金额 total_repay_ratio-->
                                <el-progress :percentage="receivableOrderOverviewData.total_repay_ratio"
                                             :stroke-width="8"
                                             :width="180"
                                             color="#2990FF"
                                             type="circle">
                                </el-progress>
                                <!--待回款金额 no_repay_ratio-->
                                <el-progress :percentage="receivableOrderOverviewData.no_repay_ratio"
                                             :stroke-width="8"
                                             :width="160"
                                             class="no_repay_ratio_progress"
                                             color="#F0AA32"
                                             type="circle">
                                </el-progress>
                                <!--总退款金额 total_refund_ratio-->
                                <el-progress :percentage="receivableOrderOverviewData.total_refund_ratio"
                                             :stroke-width="8"
                                             :width="140"
                                             class="total_refund_ratio_progress"
                                             color="#E44144"
                                             type="circle">
                                </el-progress>
                                <!--实际回款金额 repayment_ratio-->
                                <el-progress :percentage="receivableOrderOverviewData.repayment_ratio"
                                             :stroke-width="8"
                                             :width="120"
                                             class="repayment_ratio_progress"
                                             color="#5AB333"
                                             type="circle">
                                </el-progress>
                                <div v-if="receivableOrderOverviewData.chart_data" class="center_repay_price_wrap">
                                    <div class="label">实际回款金额</div>
                                    <div class="amount"
                                         v-text="'¥'+receivableOrderOverviewData.chart_data.repay_price"></div>
                                    <div class="ratio"
                                         v-text="this.receivableOrderOverviewData.repayment_ratio + '%'"></div>
                                </div>
                            </div>
                            <div v-if="receivableOrderOverviewData.chart_data" class="right_amount_wrap">
                                <div class="amount_item_wrap">
                                    <span class="amount_label amount_label_3">实际回款金额</span>
                                    <span class="amount_value"
                                          v-text="'¥'+receivableOrderOverviewData.chart_data.repay_price"></span>
                                </div>
                                <div class="amount_item_wrap">
                                    <span class="amount_label amount_label_1">待回款金额</span>
                                    <span class="amount_value"
                                          v-text="'¥'+receivableOrderOverviewData.chart_data.no_repay_price"></span>
                                </div>
                                <div class="amount_item_wrap">
                                    <span class="amount_label amount_label_2">总退款金额</span>
                                    <span class="amount_value"
                                          v-text="'¥'+receivableOrderOverviewData.chart_data.refund_price"></span>
                                </div>
                                <div class="amount_item_wrap">
                                    <span class="amount_label amount_label_4">总回款金额</span>
                                    <span class="amount_value"
                                          v-text="'¥'+receivableOrderOverviewData.chart_data.total_repay_price"></span>
                                </div>
                            </div>
                        </div>
                        <div v-if="!Array.isArray(receivableOrderOverviewData.last_repayment)&&order_list_auth"
                             class="last_invoice_wrap">
                            <div v-if="receivableOrderOverviewData.last_repayment" class="flex_js_wrap">
                                <div>
                                    <span class="title">最近回款</span>
                                </div>
                                <div class="apply_time"
                                     v-text="receivableOrderOverviewData.last_repayment.payment_date"></div>
                            </div>
                            <div v-if="receivableOrderOverviewData.last_repayment" class="flex_js_wrap">
                                <span class="payment_amount"
                                      v-text="'¥'+receivableOrderOverviewData.last_repayment.payment_amount"></span>
                                <span :class="'status_name_'+receivableOrderOverviewData.last_repayment.status"
                                      class="status_name"
                                      v-text="receivableOrderOverviewData.last_repayment.status_name"></span>
                            </div>
                        </div>
                        <div v-else :class="{'mt_16':!order_list_auth}" class="last_invoice_wrap">
                            <div class="not_yet">暂未回款</div>
                        </div>
                        <div v-if="!Array.isArray(receivableOrderOverviewData.last_refund)&&order_list_auth"
                             class="last_invoice_wrap">
                            <div v-if="receivableOrderOverviewData.last_repayment" class="flex_js_wrap">
                                <div>
                                    <span class="title">最近退款</span>
                                </div>
                                <div class="apply_time"
                                     v-text="receivableOrderOverviewData.last_refund.refund_date"></div>
                            </div>
                            <div v-if="receivableOrderOverviewData.last_refund" class="flex_js_wrap">
                                <span class="invoice_amount"
                                      v-text="'¥'+receivableOrderOverviewData.last_refund.refund_amount"></span>
                                <span :class="'status_name_'+receivableOrderOverviewData.last_refund.payment_status"
                                      class="status_name"
                                      v-text="receivableOrderOverviewData.last_refund.payment_status_name"></span>
                            </div>
                        </div>
                    </div>
                    <div class="invoice_overview_wrap">
                        <div class="flex_js_wrap">
                            <div class="page_little_title">
                                <span class="title">开票情况</span>
                            </div>
                            <el-link :underline="false"
                                     icon="el-icon-plus"
                                     type="primary"
                                     v-if="orderDetailsData.order_status === 1&&order_edit_auth"
                                     @click="handleClickAddInvoice">新建开票
                            </el-link>
                        </div>
                        <div class="invoice_overview_board">
                            <div v-if="invoiceOrderOverviewData&&order_list_auth"
                                 class="flex_js_wrap percentage_wrap">
                                <el-progress :percentage="invoiceOrderOverviewData.percentage"
                                             :stroke-width="8"
                                             :width="120"
                                             color="#2990FF"
                                             type="circle">
                                </el-progress>
                                <div class="progress_text" v-if="invoiceOrderOverviewData.percentage">
                                    <div class="percentage" v-text="invoiceOrderOverviewData.percentage+'%'"></div>
                                    <div class="text">开票占比</div>
                                </div>
                                <div class="amount_wrap">
                                    <div class="flex_js_wrap" style="margin-bottom: 8px">
                                        <span class="amount_label">开票总金额</span>
                                        <span class="amount_value"
                                              v-text="'¥'+invoiceOrderOverviewData.invoice_total_amount"></span>
                                    </div>
                                    <div class="flex_js_wrap">
                                        <span class="amount_label">可开票金额</span>
                                        <span class="amount_value"
                                              v-text="'¥'+invoiceOrderOverviewData.available_invoice_amount"></span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="invoiceOrderOverviewData&&!Array.isArray(invoiceOrderOverviewData.last_invoice)&&order_list_auth"
                                 class="last_invoice_wrap">
                                <div v-if="invoiceOrderOverviewData.last_invoice" class="flex_js_wrap">
                                    <div>
                                        <span class="title">最近开票</span>
                                        <span class="invoice_no"
                                              v-text="invoiceOrderOverviewData.last_invoice.invoice_no"></span>
                                    </div>
                                    <div class="apply_time"
                                         v-text="invoiceOrderOverviewData.last_invoice.apply_time"></div>
                                </div>
                                <div v-if="invoiceOrderOverviewData.last_invoice" class="flex_js_wrap">
                                    <span class="invoice_amount"
                                          v-text="'¥'+invoiceOrderOverviewData.last_invoice.invoice_amount"></span>
                                    <span :class="'invoice_status_name_'+invoiceOrderOverviewData.last_invoice.status"
                                          class="status_name"
                                          v-text="invoiceOrderOverviewData.last_invoice.status_name"></span>
                                </div>
                            </div>
                            <div v-else :class="{'mt_16':!order_list_auth}" class="last_invoice_wrap">
                                <div class="not_yet">暂未开票</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PurchaseDetail v-if="purchaseDetailDialog"
                        :dialogVisible.sync="purchaseDetailDialog"
                        :order_amount_field="orderAmountFieldList"
                        :order_detail="orderDetailsData"
                        :order_id="orderDetailsData.order_id"
                        @refresh="refreshDetail"/>
        <OrderAfterSale v-if="orderAfterSaleDialog"
                        :dialogVisible.sync="orderAfterSaleDialog"
                        :orderInfo="orderAfterSaleInfo"
                        :order_id="orderDetailsData.order_id"
                        @order_edit="handleClickEditOrder"
                        @refresh="afterSaleDialogRefresh"/>
        <OrderAfterSaleDetail v-if="orderAfterSaleDetailDialog"
                              :after_sale_detail="orderAfterSaleDetailData"
                              :dialogVisible.sync="orderAfterSaleDetailDialog"
                              :type="after_sale_type"
                              :type_name="after_sale_type_name"/>
        <OrderEdit v-if="editOrderDialogVisible"
                   :dialogVisible.sync="editOrderDialogVisible"
                   :order_id="orderDetailsData.order_id"
                   @refresh-list="refreshDetail"/>
        <InvoiceDialog v-if="invoiceDialogVisible"
                       :dialogVisible.sync="invoiceDialogVisible"
                       :order_id="orderDetailsData.order_num"
                       :source="'detail'"
                       :invoice_no.sync="invoice_no"
                       @refresh="invoiceDialogRefresh"/>
        <InvoiceDetailsDialog v-if="invoiceDetailsDialogVisible"
                              :dialogVisible.sync="invoiceDetailsDialogVisible"
                              :invoice_no.sync="invoice_no"/>
        <RepaymentDialog v-if="repaymentDialogVisible"
                         :dialogVisible.sync="repaymentDialogVisible"
                         :order_id="orderDetailsData.order_id"
                         :source="'detail'"
                         :receivable_no.sync="receivable_no"
                         @refresh="repaymentDialogRefresh"/>
        <RepaymentDetail v-if="repaymentDetailDialogVisible"
                         :dialogVisible.sync="repaymentDetailDialogVisible"
                         :receivable_no.sync="receivable_no"/>
        <OrderAddMember v-if="teamMembersAddVisible"
                        :dialogVisible.sync="teamMembersAddVisible"
                        :order_ids="[orderDetailsData.order_id]"
                        @refresh="getTeamMemberList"/>
        <OrderPurchaseAdd v-if="orderPurchaseAddVisible"
                          :dialogVisible.sync="orderPurchaseAddVisible"
                          :order_id="order_id"
                          @refresh="refreshDetail"/>
        <OrderSubmitAgain v-if="submitAgainOrderDialogVisible"
                          :dialogVisible.sync="submitAgainOrderDialogVisible"
                          :order_id="orderDetailsData.order_id"
                          @refresh-list="eventBusOrderList"/>
        <OutProductDetail v-if="outProductDetailDialog"
                          :outColumnId="outColumnId" :outProductDetailDialog.sync="outProductDetailDialog"/>
    </div>
</template>
<script>
import {
    cancelApproval,
    invoiceOrderOverview,
    orderAfterSaleDetail,
    orderAfterSaleList,
    orderDetail,
    orderFundsRecordList,
    orderInvoiceRecordCancel,
    orderInvoiceSummary,
    orderRepaymentRecordCancel,
    receivableOrderOverview,
    orderHasAfterSale,
    orderMemberList,
    orderMemberAuthEdit,
    orderMemberDel,
    orderClose,
    orderDel,
    stockOutList,
    orderLogList,
    workOrderList,
    getFormFields,
} from "@/api";
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import PurchaseDetail from "./component/purchase_detail";
import OrderAfterSale from "./component/order_afte_sale";
import OrderAfterSaleDetail from "./component/order_afte_sale_detail";
import OrderEdit from "@/views/pc/Order/component/order_edit";
import OrderAddMember from "@/views/pc/Order/component/add_member";
import InvoiceDialog from "./component/invoice_dialog";
import InvoiceDetailsDialog from "./component/invoice_details";
import RepaymentDialog from "./component/repayment_dialog";
import RepaymentDetail from "./component/repayment_details";
import OrderPurchaseAdd from "./component/order_purchase_add";
import OutProductDetail from "@/views/pc/InventoryManagement/component/out_product_detail";
import OrderSubmitAgain from "@/views/pc/Order/component/order_submit_again";
import afterSaleApproveDetail from "@/components/pComponents/afterSaleApproveDetail";
import {mapGetters, mapState} from "vuex";
import {throttle} from 'lodash';
import {EventBus} from '@/utils/eventBus';

export default {
    name: "OrderDetail",
    data() {
        return {
            loading: false,
            defaultImg: require('@/assets/images/default.jpg'),
            pk_id: Math.random(),
            queryType: this.$route.query.query_type, // 判断详情是根据订单id还是订单编号查询，在财务页面是没有订单id的，需要根据订单编号查询
            order_id: this.$route.query.order_id,
            order_num: this.$route.query.order_num,
            orderDetailsData: {},
            tabActiveName: 'detail',
            formInfoList: [],
            dataLoaded: false,
            purchaseDetailDialog: false,
            orderAmountFieldList: [],
            orderAfterSaleDialog: false,
            orderAfterSaleDetailData: {},
            orderAfterSaleDetailDialog: false,
            editOrderDialogVisible: false,
            invoiceDialogVisible: false,
            invoiceSummaryList: [],
            invoiceDetailsDialogVisible: false,
            invoice_no: '',
            invoiceOrderOverviewData: {},
            receivableOrderOverviewData: {},
            isCollapse: false,
            paymentRecordList: [],//款项记录
            repaymentDialogVisible: false,
            repaymentDetailDialogVisible: false,
            receivable_no: '',
            afterSaleList: [],
            stockOutList: [],
            teamMemberList: [],
            listLoading: false,
            after_sale_type_name: '',
            after_sale_type: '',
            teamMembersAddVisible: false,
            orderPurchaseAddVisible: false,
            submitAgainOrderDialogVisible: false,
            outProductDetailDialog: false,//出库详情
            outColumnId: 0,
            orderLogList: [],
            workOrderList: [],
            orderAfterSaleInfo: {},//订单售后需要的参数
            permission: {}
        }
    },
    components: {
        CustomFormDetailPc,
        PersonnelCard,
        PurchaseDetail,
        OrderAfterSale,
        OrderAfterSaleDetail,
        OrderEdit,
        InvoiceDialog,
        InvoiceDetailsDialog,
        RepaymentDialog,
        RepaymentDetail,
        OrderAddMember,
        OrderPurchaseAdd,
        OrderSubmitAgain,
        OutProductDetail,
        afterSaleApproveDetail
    },
    created() {
        this.getOrderDetail()
    },
    mounted() {
    },
    computed: {
        ...mapState(["userInfo"]),
        ...mapGetters(['hasPermission']),
        hasClosePermission() {
            return this.hasPermission('order.close', 'customer', 'Order');
        },
        order_edit_auth() {
            return this.permission['order.edit'];
        },
        //订单列表查看权限
        order_list_auth() {
            return this.permission['order.list'];
        },
        //是否可以新增代采
        order_purchase_add_auth() {
            return this.orderDetailsData.order_status === 1 && this.orderDetailsData.purchase_price && Number(this.orderDetailsData.purchase_price.value) !== 0 && this.order_edit_auth
        },
    },
    methods: {
        // 获取订单详情
        getOrderDetail() {
            this.loading = true
            this.dataLoaded = false
            let params = {}
            if (this.queryType && this.queryType === 'order_num') {
                params.order_id = this.order_num
            } else {
                params.order_id = this.order_id
            }
            orderDetail(params).then(res => {
                if (res.code === 200) {
                    this.orderDetailsData = res.data
                    this.permission = res.data.permission
                    this.orderAfterSaleInfo = {
                        order_num: res.data.order_num,
                        customer_name: res.data.customer_id?.text
                    }
                    this.formInfoList = res.data.custom_fields
                    if (this.queryType && this.queryType === 'order_num') {
                        this.order_num = res.data.order_num
                    }
                    if (this.orderDetailsData.return_goods && this.orderDetailsData.return_goods.length > 0) {
                        this.orderDetailsData.order_goods = this.orderDetailsData.order_goods.concat(this.orderDetailsData.return_goods)
                    }
                    this.dataLoaded = true
                    if (this.order_list_auth) {
                        invoiceOrderOverview({
                            order_num: res.data.order_num
                        }).then(res => {
                            if (res.code === 200) {
                                this.invoiceOrderOverviewData = res.data
                                this.invoiceOrderOverviewData.percentage = Number(res.data.available_invoice_amount) === 0 ? 0 : Number((Number(res.data.invoice_total_amount) / Number(res.data.available_invoice_amount) * 100).toFixed(2))
                                this.loading = false
                            } else {
                                this.loading = false
                            }
                        })
                        receivableOrderOverview({
                            order_num: res.data.order_num
                        }).then(res => {
                            if (res.code === 200) {
                                this.receivableOrderOverviewData = res.data
                                const total_price = Number(this.receivableOrderOverviewData.chart_data.total_price)
                                //总回款金额比例
                                const total_repay_ratio = total_price === 0 ? 0 : Number(this.receivableOrderOverviewData.chart_data.total_repay_price) / total_price * 100
                                this.receivableOrderOverviewData.total_repay_ratio = Number(total_repay_ratio.toFixed(2))
                                //实际回款金额比例=实际回款金额/订单总金额*100%
                                const repayment_ratio = total_price === 0 ? 0 : Number(this.receivableOrderOverviewData.chart_data.repay_price) / total_price * 100
                                this.receivableOrderOverviewData.repayment_ratio = Number(repayment_ratio.toFixed(2))
                                //总退款金额比例
                                const total_refund_ratio = total_price === 0 ? 0 : Number(this.receivableOrderOverviewData.chart_data.refund_price) / total_price * 100
                                this.receivableOrderOverviewData.total_refund_ratio = Number(total_refund_ratio.toFixed(2))
                                //待回款金额比例
                                const no_repay_ratio = total_price === 0 ? 0 : Number(this.receivableOrderOverviewData.chart_data.no_repay_price) / total_price * 100
                                this.receivableOrderOverviewData.no_repay_ratio = Number(no_repay_ratio.toFixed(2))
                                this.loading = false
                            } else {
                                this.loading = false
                            }
                        })
                    } else {
                        this.isCollapse = true
                        this.loading = false
                    }
                } else {
                    this.loading = false
                }
            })
        },

        refreshDetail() {
            this.getOrderDetail()
            this.eventBusOrderList()
        },

        //复制订单编号
        handleClickCopyOrderNum() {
            const textarea = document.createElement('textarea');
            textarea.value = this.orderDetailsData.order_num;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            // 移除临时元素
            document.body.removeChild(textarea);
            this.$message.success('复制成功');
        },

        //编辑订单
        handleClickEditOrder() {
            this.editOrderDialogVisible = true
        },

        handleClickTab() {
            switch (this.tabActiveName) {
                case 'order':
                    this.getOrderDetail()
                    break
                case 'invoice':
                    this.getInvoiceSummaryList()
                    break
                case 'payment':
                    this.getTransactionRecords()
                    break
                case 'afterSales':
                    this.getAfterSaleList()
                    break
                case 'outStock':
                    this.getStockOutList()
                    break
                case 'workOrder':
                    this.getWorkOrderList()
                    break
                case 'member':
                    this.getTeamMemberList()
                    break
                case 'log':
                    this.getOrderLogList()
                    break
            }
        },

        //点击展开订单详情，收起回款和开票
        handleClickCollapse() {
            this.isCollapse = !this.isCollapse
        },

        //点击查看采购明细
        handleClickShowPurchaseDetail() {
            if (this.orderAmountFieldList.length === 0) {
                getFormFields({
                    field_form: 'orders'
                }).then(res => {
                    if (res.code === 200) {
                        this.orderAmountFieldList = res.data.find(item => item.field_key === 'amount_information')._child || []
                        this.purchaseDetailDialog = true
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.purchaseDetailDialog = true
            }
        },

        //点击新增回款
        handleClickAddRepayment() {
            this.repaymentDialogVisible = true
        },

        //获取款项列表
        getTransactionRecords() {
            this.listLoading = true
            orderFundsRecordList({
                order_no: this.orderDetailsData.order_num,
                page: 1,
                pageSize: 1000
            }).then(res => {
                if (res.code === 200) {
                    this.paymentRecordList = res.data
                }
                this.listLoading = false
            })
        },

        //点击回款记录详情
        handleClickRepaymentDetail(row) {
            if (row.type !== 'repayment') return false
            this.receivable_no = row.receivable_no
            this.repaymentDetailDialogVisible = true
        },

        //撤销款项记录
        handleClickPaymentRevoke(row) {
            this.$msgbox({
                title: '确定撤销当前回款记录？',
                message: '撤销后不可恢复，请谨慎操作！',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_warning',
            }).then(() => {
                orderRepaymentRecordCancel({
                    receivable_no: row.receivable_no
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('撤销成功！')
                        this.getTransactionRecords()
                    }
                })
            }).catch(() => {
                return false
            })
        },

        //款项记录重新发起
        handleClickPaymentAgain(row) {
            this.receivable_no = row.receivable_no
            this.repaymentDialogVisible = true
        },

        //回款申请完成后刷新列表
        repaymentDialogRefresh() {
            this.getTransactionRecords()
            this.getOrderDetail()
            this.eventBusOrderList()
        },

        //点击新建开票
        handleClickAddInvoice() {
            this.invoiceDialogVisible = true
        },

        //开票申请完成后刷新列表
        invoiceDialogRefresh() {
            this.getInvoiceSummaryList()
            this.getOrderDetail()
        },

        //点击开票详情
        handleClickInvoiceDetail(row) {
            this.invoice_no = row.invoice_no
            this.invoiceDetailsDialogVisible = true
        },

        //获取开票管理列表
        getInvoiceSummaryList() {
            this.listLoading = true
            orderInvoiceSummary({
                order_no: this.orderDetailsData.order_num,
                page: 1,
                pageSize: 1000
            }).then(res => {
                if (res.code === 200) {
                    this.invoiceSummaryList = res.data.data
                }
                this.listLoading = false
            })
        },

        //点击重新发起开票申请
        handleClickInvoiceAgain(row) {
            this.invoice_no = row.invoice_no
            this.invoiceDialogVisible = true
        },

        //点击撤销开票申请
        handleClickInvoiceRevoke(row) {
            this.$msgbox({
                title: '确定撤销当前开票记录？',
                message: '撤销后不可恢复，请谨慎操作！',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_warning',
            }).then(() => {
                orderInvoiceRecordCancel({
                    invoice_no: row.invoice_no
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('撤销成功！')
                        this.getInvoiceSummaryList()
                    }
                })
            }).catch(() => {
                return false
            })
        },

        //订单售后
        handleClickAfterSales() {
            orderHasAfterSale({
                order_id: this.orderDetailsData.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$message.error(res.data.tips)
                    } else {
                        this.orderAfterSaleDialog = true
                    }
                }
            })
        },

        //获取售后记录列表
        getAfterSaleList() {
            this.listLoading = true
            orderAfterSaleList({
                order_id: this.orderDetailsData.order_id
            }).then(res => {
                if (res.code === 200) {
                    res.data.forEach(item => {
                        switch (item.approval_status) {
                            case 0:
                                item.approval_status_name = '审批中'
                                break
                            case 1:
                                item.approval_status_name = '已通过'
                                break
                            case 2:
                                item.approval_status_name = '已拒绝'
                                break
                            case 3:
                                item.approval_status_name = '已撤销'
                                break
                        }
                    })
                    this.afterSaleList = res.data
                }
                this.listLoading = false
            })
        },

        afterSaleDialogRefresh() {
            this.getAfterSaleList()
        },

        //售后记录撤销
        handleClickAfterSaleRevoke(row) {
            this.$msgbox({
                title: '撤销',
                message: '是否撤销该售后操作?',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_warning',
            }).then(() => {
                cancelApproval({
                    approval_id: row.approval_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('撤销成功！')
                        this.getAfterSaleList()
                    }
                })
            }).catch(() => {
            })
        },

        //售后记录详情
        handleClickAfterSaleDetail(row) {
            this.after_sale_type = row.type
            this.after_sale_type_name = row.type_name
            orderAfterSaleDetail({
                type: row.type,
                relate_id: row.relate_id,
            }).then(res => {
                if (res.code === 200) {
                    this.orderAfterSaleDetailData = res.data
                    this.orderAfterSaleDetailDialog = true
                }
            })
        },

        //复制订单
        handleClickCopyOrder() {
            this.submitAgainOrderDialogVisible = true
        },

        //重新发起
        handleClickSubmitAgain() {
            this.submitAgainOrderDialogVisible = true
        },

        //删除订单
        handleClickDelOrder() {
            this.$msgbox({
                title: '您确定要删除吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                iconClass: 'iconfont icon-yiwen',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger',
                confirmButtonClass: "el-button--danger",
            }).then(() => {
                orderDel({
                    order_id: this.orderDetailsData.order_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功！')
                        this.$router.go(-1)
                        this.eventBusOrderList()
                    }
                })
            }).catch(() => {
                return false
            })
        },

        // 撤销订单
        handleClickRevokeOrder() {
            this.$msgbox({
                title: '确认撤销吗？',
                message: '撤销后不可恢复，请谨慎操作！',
                confirmButtonText: '撤销',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                cancelApproval({
                    approval_id: this.orderDetailsData.approval_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('撤销成功')
                        this.refreshDetail()
                    }
                })
            })
        },

        //关闭订单
        handleClickCloseOrder() {
            this.$msgbox({
                title: '您确定要关闭吗？',
                message: '关闭后不可恢复，请谨慎操作！',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                iconClass: 'iconfont icon-yiwen',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger',
                confirmButtonClass: "el-button--danger",
            }).then(() => {
                orderClose({
                    order_id: this.orderDetailsData.order_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('关闭成功！')
                        this.refreshDetail()
                    }
                })
            }).catch(() => {
                return false
            })
        },

        //添加代采
        handleClickAddPurchase() {
            orderHasAfterSale({
                order_id: this.orderDetailsData.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$message.error(res.data.tips)
                    } else {
                        this.orderPurchaseAddVisible = true
                    }
                }
            })
        },

        //获取出库列表
        getStockOutList() {
            this.listLoading = true
            stockOutList({
                order_ids: [this.orderDetailsData.order_id],
                page: 1,
                pageSize: 50,
            }).then(res => {
                if (res.code === 200) {
                    this.stockOutList = res.data.list
                }
                this.listLoading = false
            })
        },

        //点击出库记录详情
        handleClickOutStockDetail(row) {
            this.outColumnId = row.id
            this.outProductDetailDialog = true
        },

        //获取关联工单订单
        getWorkOrderList() {
            this.listLoading = true
            workOrderList({
                order_id: this.orderDetailsData.order_id,
                page: 1,
                pageSize: 100
            }).then(res => {
                this.workOrderList = res.data.data
                this.listLoading = false
            })
        },

        //点击工单详情
        handleClickWorkOrderDetail(row) {
            this.$router.push({
                name: "WorkOrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                    name: row.workorder_num,
                },
            });
        },

        //获取团队成员列表
        getTeamMemberList() {
            this.listLoading = true
            orderMemberList({
                order_id: this.orderDetailsData.order_id
            }).then(res => {
                if (res.code === 200) {
                    this.teamMemberList = res.data
                }
                this.listLoading = false
            })
        },

        //添加成员
        handleClickAddMember() {
            this.teamMembersAddVisible = true
        },

        //打印订单
        handleClickPrintTheOrder() {

        },

        //团队成员权限切换
        handleOrderMemberAuthChange: throttle(function (row) {
            orderMemberAuthEdit({
                order_id: this.orderDetailsData.order_id,
                member_uid: row.member_uid,
                auth: row.auth
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('修改成功');
                    this.getTeamMemberList();
                }
            });
        }, 2000), // 设置节流间隔为 2000 毫秒（2秒）

        //移除成员
        handleClickRemoveMember(row) {
            orderMemberDel({
                order_id: this.orderDetailsData.order_id,
                member_uid: row.member_uid
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('移除成功');
                    this.getTeamMemberList();
                }
            })
        },

        //获取订单日志列表
        getOrderLogList() {
            this.listLoading = true
            orderLogList({
                order_id: this.orderDetailsData.order_id
            }).then(res => {
                if (res.code === 200) {
                    this.orderLogList = res.data.data
                    this.listLoading = false
                }
            })
        },

        eventBusOrderList() {
            EventBus.$emit('orderUpdated');
        },
    },
}
</script>
<style lang="scss" scoped>
.detail_outer_wrap {
    width: 100%;
    height: 100%;
    background-color: #EDF0F4;
    overflow: hidden;

    .detail_top_wrap {
        padding: 16px 16px 12px;
        background-color: #FFFFFF;

        h2 {
            color: #333333;
            font-size: 18px;
            line-height: 28px;
            margin-right: 4px;
        }

        .flex_js_wrap {
            margin-bottom: 8px;
        }

        .company_name {
            line-height: 22px;
            color: #666666;
            display: inline-block;
        }

        .create_date {
            color: #666666;
            line-height: 22px;
            display: inline-block;
        }
    }

    .detail_bottom_wrap {
        width: 100%;
        height: calc(100% - 86px);
        padding: 4px;
        display: flex;
        align-items: center;
        gap: 4px;

        .bottom_left_wrap {
            height: 100%;
            width: calc(100% - 420px);
            background-color: #FFFFFF;
            border-radius: 6px;
            position: relative;
            transition: width .3s;

            .collapse_button {
                width: 12px;
                height: 32px;
                border-radius: 6px;
                background: #ABABAB;
                text-align: center;
                line-height: 32px;
                position: absolute;
                right: -6px;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                z-index: 999;

                &:hover {
                    background-color: #2990FF;
                }

                &:active {
                    background-color: #2279D6;
                }

                i {
                    color: #FFFFFF;
                    font-size: 8px;
                }
            }

            .order_detail_wrap {
                overflow-y: auto;
            }

            .invoice_table_wrap {
                overflow-y: auto;
                max-height: calc(100% - 48px);
            }

            &.is_collapse {
                width: 100%;
            }

            .order_log_list {
                padding: 0 4px;

                .order_log_item {
                    padding-left: 20px;
                    margin-bottom: 16px;
                    border-left: 1px dashed #E8E8E8;
                    position: relative;

                    &::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -8px;
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        border: 4px solid #2990FF;
                        background-color: #FFFFFF;
                        box-sizing: content-box;
                    }

                    .created_at {
                        font-size: 12px;
                        line-height: 22px;
                        color: #666666;
                        margin-left: 4px;
                    }

                    .log_content_wrap {
                        border-radius: 6px;
                        background: #EDF0F4;
                        padding: 8px 12px;
                        margin-top: 8px;

                        .log_content {
                            color: #666666;
                            line-height: 22px;
                        }

                        .order_edit_content {
                            padding: 12px;
                            background-color: #FFFFFF;
                            border-radius: 6px;
                            margin-top: 8px;
                        }
                    }
                }
            }
        }

        .bottom_right_wrap {
            height: 100%;
            width: 420px;
            display: flex;
            flex-direction: column;
            gap: 4px;
            transition: width .3s;

            .payments_overview_wrap {
                flex: 0.5;
                background-color: #FFFFFF;
                border-radius: 6px;
                padding: 16px;

                .payments_chart_wrap {
                    padding: 24px 0 18px;
                    gap: 16px;

                    .left_progress_wrap {
                        width: 180px;
                        height: 180px;
                        position: relative;

                        .center_repay_price_wrap {
                            width: 150px;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            text-align: center;

                            .label {
                                font-size: 12px;
                                color: #999999;
                                line-height: 18px;
                            }

                            .amount {
                                font-size: 16px;
                                font-weight: 700;
                                line-height: 24px;
                                color: #333333;
                            }

                            .ratio {
                                font-size: 12px;
                                color: #666666;
                                line-height: 18px;
                            }
                        }

                        ::v-deep .el-progress__text {
                            display: none;
                        }

                        .no_repay_ratio_progress, .total_refund_ratio_progress, .repayment_ratio_progress {
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }

                    .right_amount_wrap {
                        flex: 1;

                        .amount_item_wrap {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            line-height: 22px;
                            margin-bottom: 8px;

                            .amount_label {
                                color: #666666;

                                &::before {
                                    content: '';
                                    display: inline-block;
                                    width: 6px;
                                    height: 6px;
                                    border-radius: 50%;
                                    margin-right: 4px;
                                    vertical-align: middle;
                                }

                                &.amount_label_1::before {
                                    background-color: #F0AA32;
                                }

                                &.amount_label_2::before {
                                    background-color: #E44144;
                                }

                                &.amount_label_3::before {
                                    background-color: #5AB333;
                                }

                                &.amount_label_4::before {
                                    background-color: #2990FF;
                                }
                            }

                            .amount_value {
                                color: #333333;
                                font-weight: bold;
                                vertical-align: middle;
                            }
                        }
                    }
                }
            }

            .invoice_overview_wrap {
                flex: 0.5;
                background-color: #FFFFFF;
                border-radius: 6px;
                padding: 16px;

                .invoice_overview_board {
                    .percentage_wrap {
                        gap: 50px;
                        padding: 24px 16px 18px;
                        position: relative;

                        .progress_text {
                            position: absolute;
                            left: 40px;
                            text-align: center;
                            background-color: #FFFFFF;
                            width: 75px;

                            .percentage {
                                font-size: 16px;
                                font-weight: 700;
                                line-height: 24px;
                                color: #2990FF;
                            }

                            .text {
                                font-size: 12px;
                                line-height: 18px;
                                color: #999999;
                            }
                        }
                    }
                }
            }

            .last_invoice_wrap {
                border: 2px solid #EDF0F4;
                border-radius: 6px;
                padding: 10px;
                margin-bottom: 12px;

                .title {
                    font-weight: 700;
                    line-height: 22px;
                    color: #333333;
                }

                .invoice_no {
                    line-height: 22px;
                    color: #666666;
                    margin-left: 4px;
                }

                .apply_time {
                    font-size: 12px;
                    line-height: 18px;
                    color: #999999;
                }

                .invoice_amount {
                    font-weight: 700;
                    line-height: 22px;
                    color: #E44144;
                }

                .payment_amount {
                    font-weight: 700;
                    line-height: 22px;
                    color: #5AB333;
                }

                .not_yet {
                    font-size: 12px;
                    color: #999999;
                    text-align: center;
                    height: 44px;
                    line-height: 44px;
                }
            }

            .page_little_title {
                margin-bottom: 0;
            }

            &.is_collapse {
                width: 0;
            }

            .amount_wrap {
                flex: 1;

                .amount_label {
                    line-height: 22px;
                    color: #666666;
                }

                .amount_value {
                    font-weight: 700;
                    line-height: 22px;
                    color: #333333;
                }
            }
        }

        .status_name {
            color: #666666;
            vertical-align: middle;
            margin-right: 4px;

            &::before {
                content: '';
                width: 6px;
                height: 6px;
                border-radius: 50%;
                display: inline-block;
                vertical-align: middle;
                margin-right: 4px;
            }

            &.status_name_1::before {
                background: #F0AA32;
            }

            &.status_name_2::before {
                background: #5AB333;
            }

            &.status_name_3::before {
                background: #E44144;
            }

            &.status_name_4::before {
                background: #F0AA32;
            }

            &.invoice_status_name_1::before {
                background: #F0AA32;
            }

            &.invoice_status_name_2::before {
                background: #5AB333;
            }

            &.invoice_status_name_3::before {
                background: #E44144;
            }

            &.invoice_status_name_4::before {
                background: #E44144;
            }

            &.invoice_status_name_5::before {
                background: #BFBFBF;
            }

            &.payment_status_name_1::before {
                background: #F0AA32;
            }

            &.payment_status_name_2::before {
                background: #5AB333;
            }

            &.payment_status_name_3::before {
                background: #E44144;
            }

            &.payment_status_name_4::before {
                background: #BFBFBF;
            }

            &.payment_status_name_5::before {
                background: #E44144;
            }

            &.approval_status_0::before {
                background: #F0AA32;
            }

            &.approval_status_1::before {
                background: #5AB333;
            }

            &.approval_status_2::before {
                background: #E44144;
            }

            &.approval_status_3::before {
                background: #BFBFBF;
            }
        }

        .refund_amount {
            color: #e44144;
        }
    }
}
</style>